import { ContractConsentsTypeEnum } from 'containers/contract/types/contract-api-data-api-response.type';

// Domain
const DOMAIN = 'lending.services.public.onboarding.lzOnboarding.contractContainer.contractual.';

const AT_THE_TIME_OF_SHIPPING = `${DOMAIN}atTheTimeOfShipping`,
  CONSENTS_TITLE = `${DOMAIN}consentsTitle`,
  DESCRIPTION = `${DOMAIN}description`,
  DOWNLOAD_CONTRACT_INFORMATION = `${DOMAIN}link`,
  DOWNLOAD_LINK_CONTRACT = `${DOMAIN}documentName`,
  EVERY_MONTH = `${DOMAIN}everyMonth`,
  INFORMATION_TITLE = `${DOMAIN}financialTitle`,
  INTEREST = `${DOMAIN}interest`,
  LEGAL_CONSENTS_TEXT = `${DOMAIN}legalConsentsText`,
  LINK = `${DOMAIN}link`,
  PAYMENT_METHOD = `${DOMAIN}paymentMethod`,
  PDF_TITLE = `${DOMAIN}pdfTitle`,
  PRIVACY_POLICY_LINK = `${DOMAIN}privacyPolicyLink`,
  PRIVACY_POLICY_TITLE = `${DOMAIN}consultPrivacyPolicyTitle`,
  SIGNATURE_DATE = `${DOMAIN}signatureDate`,
  TOTAL_AMOUNT = `${DOMAIN}totalAmount`,
  TOTAL_BASKET_AMOUNT = `${DOMAIN}totalBasketAmount`,
  TITLE = `${DOMAIN}title`;

const CONSENT = (consent: ContractConsentsTypeEnum): string => `${DOMAIN}${consent.toString()}`;

export {
  AT_THE_TIME_OF_SHIPPING,
  CONSENT,
  CONSENTS_TITLE,
  DESCRIPTION,
  DOWNLOAD_CONTRACT_INFORMATION,
  DOWNLOAD_LINK_CONTRACT,
  EVERY_MONTH,
  INFORMATION_TITLE,
  INTEREST,
  LEGAL_CONSENTS_TEXT,
  LINK,
  TITLE,
  PAYMENT_METHOD,
  PDF_TITLE,
  PRIVACY_POLICY_LINK,
  PRIVACY_POLICY_TITLE,
  SIGNATURE_DATE,
  TOTAL_BASKET_AMOUNT,
  TOTAL_AMOUNT,
};
